import { Component, OnInit } from '@angular/core';
import {MatDialog} from '@angular/material';
import {CalculatorDialogComponent} from '../calculator-dialog/calculator-dialog.component';
import { StudentInfoService } from '../../_services/student-info.service';
@Component({
  selector: 'app-student-calculator',
  templateUrl: './student-calculator.component.html',
  styleUrls: ['./student-calculator.component.css'],
  providers: [StudentInfoService]
})
export class StudentCalculatorComponent implements OnInit {
  public schoolData: any= [];
  public secondFlag = false;
  public thirdFlag = false;
  constructor(public dialog: MatDialog, public api: StudentInfoService
  ) { }

  ngOnInit() {
    this.fetchSchoolComparisonData();
  }
  fetchSchoolComparisonData() {
    this.api.getStudentInfo()
    .subscribe(
      data => {
        const resData = JSON.parse(data._body);
        if (resData.status === 0) {
          this.schoolData = [];
        }else {
          this.schoolData = resData.data;
        }
        if (this.schoolData.length === 1) {
          this.secondFlag = true;
          this.thirdFlag = true;
        }else if (this.schoolData.length === 2) {
          this.secondFlag = false;
          this.thirdFlag = true;
        }else {
          this.secondFlag = false;
          this.thirdFlag = false;
        }
      },
      error => {
        console.log(error);
      },
    );
  }
  remove(e) {
    this.api.removeInfo(e).subscribe(
      data => {
        console.log(data);
        this.fetchSchoolComparisonData();
      },
      error => {
        console.log(error);
      },
    );
  }
  openDialog() {
    const dialogRef = this.dialog.open(CalculatorDialogComponent, {
      height: '600px',
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
      this.fetchSchoolComparisonData();
    });
  }

}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/student-calculator/student-calculator.component.ts